import {scrollToTarget} from '../utils/scrollToTarget'

class AnchorLink {
  constructor(element) {
    this.element = element
    
    this.element.addEventListener('click', evt => {
      
      evt.preventDefault()
      
      const targetHref = evt.currentTarget.getAttribute('href')
      
      let baseUrl = location.href.split('#')[0]
      let baseTargetUrl = targetHref.split('#')[0]
  
      if (baseUrl === baseTargetUrl && targetHref.indexOf('#') > -1) {
        const target = document.querySelector('[data-target=' + targetHref.split('#')[1]  + ']')
        if (target) {
          
          setTimeout( () => {
            scrollToTarget(target)
          }, 500)
        }
      } else {
        const targetTarget = evt.currentTarget.getAttribute('target')
        
        if (evt.ctrlKey || evt.metaKey || evt.which === 3 || targetTarget === '_blank') {
          window.open(targetHref)
        } else {
          window.location = targetHref
        }
      }
    })
  }
}

export default AnchorLink
